import * as yup from "yup";

export const deserializedSuppliesFormSchema = yup
  .object()
  .shape({
    supplies: yup.array().of(
      yup.object().shape({
        materialId: yup.string(),
        value: yup.number(),
        unit: yup.string(),
      })
    ),
  })
  .defined();
